import LotteryNumlotStatsContainer from "../../components/lottery/containers/LotteryNumlotStatsContainer";
import LotteryNumlotStatsTemplate from "../../components/lottery/templates/LotteryNumlotStatsTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Bingo5Stats() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="bg5" />
      <section className="min-h-screen">
        <LotteryNumlotStatsContainer lotteryKey="bg5" Template={LotteryNumlotStatsTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="bg5" />
    </>
  );
}
export default Bingo5Stats;